import * as React from 'react';
import { Button, Outside, Popover } from '@cian/ui-kit';
import { PromoMenu, PromoMenuControl } from '../../../components/PromoMenu';
import { IPromo } from '../../../types/developer/promos';
import { copyToClipboard } from '../../../utils/copyToClipboard';

interface IPromoMenuContainerProps {
  promo: IPromo;
}

export function PromoMenuContainer({ promo }: IPromoMenuContainerProps) {
  const [isOpened, setOpened] = React.useState(false);
  const [isTokenCopied, setTokenCopied] = React.useState(false);
  const contentRef = React.useRef(null);
  const buttonRef = React.useRef(null);

  const onToggleClick = React.useCallback(() => {
    setTokenCopied(false);
    setOpened(!isOpened);
  }, [isOpened]);

  const onOutside = React.useCallback(() => {
    setTokenCopied(false);
    setOpened(false);
  }, []);

  const onTokenButtonClick = React.useCallback(() => {
    //Нереальный кейс
    /* istanbul ignore if */
    if (!promo.erId) {
      return;
    }

    copyToClipboard(promo.erId);
    setTokenCopied(true);
  }, [promo.erId]);

  if (!promo.erId || !promo.hasCallbackPopup) {
    return null;
  }

  return (
    <Outside active={isOpened} insideRefs={[buttonRef, contentRef]} onOutside={onOutside}>
      <div>
        <Popover
          placement="bottom-end"
          flip={false}
          content={
            <PromoMenu ref={contentRef}>
              <Button
                size="XS"
                onClick={onTokenButtonClick}
                theme="fill_white_primary"
                data-testid="PromoMenuClipboardButton"
              >
                {isTokenCopied ? 'Токен скопирован' : 'Скопировать токен'}
              </Button>
            </PromoMenu>
          }
          open={isOpened}
        >
          <PromoMenuControl ref={buttonRef} onClick={onToggleClick} active={isOpened} />
        </Popover>
      </div>
    </Outside>
  );
}
